import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthStore } from './auth.store';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
    const authStore = inject(AuthStore);

    const token = authStore.token();
    const authRequest = token
        ? request.clone({
              setHeaders: {
                  Authorization: `Bearer ${token}`,
                  'app-origin': 'painel'
              }
          })
        : request.clone({
              setHeaders: {
                  'app-origin': 'painel'
              }
          });

    return next(authRequest);
};
